<template>
	<div class="modal-body" :class="{'has-sidebar': fixedWirelessProviders && fixedWirelessProviders.length}">
		<div class="modal-content" v-if="!success">
			<h5>There are no Fibre providers in your area.</h5>
			<form method="POST" enctype="application/json" action="https://clientzone.afrihost.com/en/api/of/fibre-injection">
				<input type="hidden" name="place[building_name]" :value="place.building_name" />
				<input type="hidden" name="place[city]" :value="place.city" />
				<input type="hidden" name="place[country_code]" :value="place.country_code" />
				<input type="hidden" name="place[formatted_address]" :value="place.formatted_address" />
				<input type="hidden" name="place[google_place_id]" :value="place.google_place_id" />
				<input type="hidden" name="place[latitude]" :value="place.latitude" />
				<input type="hidden" name="place[longitude]" :value="place.longitude" />
				<input type="hidden" name="place[name]" :value="place.name" />
				<input type="hidden" name="place[state]" :value="place.state" />
				<input type="hidden" name="place[state_code]" :value="place.state_code" />
				<input type="hidden" name="place[street_name]" :value="place.street_name" />
				<input type="hidden" name="place[street_number]" :value="place.street_number" />
				<input type="hidden" name="place[suburb]" :value="place.suburb" />
				<input type="hidden" name="place[unit_number]" :value="place.unit_number" />
				<input type="hidden" name="colour_version" value="" autocomplete="off">
				<input type="hidden" name="ga_linker" value="false" autocomplete="off">
				<p>Enter your details below and we'll notify you when Fibre becomes available in your area. If you're sure you have Fibre in your area, <button type="submit" class="texty">sign up here</button>.</p>
			</form>
			<form @submit.prevent="submit()" class="modal-form">
			<div class="form-inputs">
				<input-text label="First Name" type="text" v-model="user.first_name" :required="true"></input-text>
				<input-text label="Last Name" type="text" v-model="user.last_name" :required="true"></input-text>
				<input-text label="Email Address" type="email" v-model="user.username" :required="true"></input-text>
			</div><!-- end.form-inputs -->
			<div class="modal-footer">
				<div class="form-footer-column">
					<router-link :to="{name: 'coverage'}" class="btn white">Edit Address</router-link>
				</div><!-- end.form-footer-column -->
				<div class="form-footer-column">
					<!--<a href="#" class="text-link">I'm Sure I have Fibre</a>-->
					<button type="submit" class="btn gradient-red">Notify Me</button>
				</div><!-- end.modal-footer-column -->
			</div>
		</form>
		</div><!-- end.modal-content -->
		<div class="modal-content is-centered" v-if="success">
			<h5>Thanks, {{ user.first_name }}.</h5>
			<p>We will notify you when your address is Fibre ready.</p>
		</div>
		<aside class="modal-sidebar" v-if="fixedWirelessProviders && fixedWirelessProviders.length">
			<div class="sidebar-content upsell">
				<h6>Don't worry. You have Fixed Wireless coverage!</h6>
				<p>Get wireless LTE up to 50Mbps</p>
				<p>Get connected in days, not weeks. All LTE packages include a snazzy LTE router to easily hook up your entire household to blisteringly fast wireless internet.</p>
				<a :href="`https://afrihost.com/landing/fixed_wireless/?address=${place.formatted_address}`" class="btn white">Find Out More</a>
			</div><!-- end.sidebar-content -->
		</aside><!-- end.modal-sidebar -->
	</div>
</template>
<script>
	import InputText from '../components/InputText'
	export default {
		components: {
			InputText,
		},
		computed: {
			place() {
				return this.$store.getters['coverage/formattedPlace'];
			},
			fixedWirelessProviders() {
				return this.$store.getters['coverage/fixedWirelessProviders'];
			}
		},
		data() {
			return {
				success: false,
				error: false,
				user: {
					first_name: '',
					last_name: '',
					username: ''
				}
			}
		},
		methods: {
			submit() {
				this.$parent.$emit('toggle-loading', true);
				this.$store.dispatch('coverage/showInterest', {
					user: this.user
				}).then(() => {
					this.$parent.$emit('toggle-loading', false);
					this.success = true;
				}, () => {
					// @TODO - show an error here
					this.$parent.$emit('toggle-loading', false);
					this.success = true;
				})
			}
		}
	}
</script>
